export enum HelloSignWorkflowSessionStatus {
  CREATED = "CREATED",
  SIGNED = "SIGNED",
  ERRORED = "ERRORED",
  COMPLETED = "COMPLETED",
}

export enum HelloSignErrorCodes {
  NOTHING_TO_SIGN = "nothing_to_sign",
  NETWORK_ERROR = "network_error",
}

export enum HelloSignErrorReason {
  TIMEOUT = "timeout",
  HELLOSIGN_ERROR = "hellosign_error",
  BACKEND_ERROR = "backend_error",
  MISSING_DOCUMENT = "missing_document",
  ALREADY_SIGNED = "already_signed",
}
